// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"2b60abfe","839":"df67d096","977":"ca4fc91c"}[chunkId] + ".chunk.js";
};